import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = [
    'modal',
    'textarea'
  ]

  show(event) {
    event.preventDefault()

    this.modalTarget.classList.remove('hidden')
    
    if (this.hasTextareaTarget) {
      this.textareaTarget.focus()
    }
  }

  hide(event) {
    if (event.target === event.currentTarget || event.target.classList.contains('close')) {
      event.preventDefault()
      event.stopPropagation()
      this.hideModal()
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.hideModal()
  }

  hideModal() {
    this.modalTarget.classList.add('hidden')
    this.clearForm()
  }

  clearForm() {
    if (this.hasTextareaTarget) {
      this.textareaTarget.value = ''
    }
  }
}
